import React from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AdvertorialPage } from './pages/AdvertorialPage';
import { LandingPage888 } from './pages/LandingPage888';
export function App() {
  return <ChakraProvider data-id="element-0">
      <BrowserRouter data-id="element-1">
        <Routes data-id="element-2">
          {/* Advertorial Routes */}
          <Route path="/" element={<AdvertorialPage data-id="element-4" />} data-id="element-3" />
          <Route path="/dinero1" element={<AdvertorialPage checkoutUrl="https://pay.hotmart.com/G105090565O?checkoutMode=10&src=dinero1" data-id="element-6" />} data-id="element-5" />
          <Route path="/dinero2" element={<AdvertorialPage checkoutUrl="https://pay.hotmart.com/G105090565O?checkoutMode=10&src=dinero2" data-id="element-8" />} data-id="element-7" />
          <Route path="/dinero3" element={<AdvertorialPage checkoutUrl="https://pay.hotmart.com/G105090565O?checkoutMode=10&src=dinero3" data-id="element-10" />} data-id="element-9" />
          <Route path="/dinero4" element={<AdvertorialPage checkoutUrl="https://pay.hotmart.com/G105090565O?checkoutMode=10&src=dinero4" data-id="element-12" />} data-id="element-11" />
          <Route path="/dinero5" element={<AdvertorialPage checkoutUrl="https://pay.hotmart.com/G105090565O?checkoutMode=10&src=dinero5" data-id="element-14" />} data-id="element-13" />
        </Routes>
      </BrowserRouter>
    </ChakraProvider>;
}